import { Component, Input } from '@angular/core';

import { Table } from '../../classes/table';

@Component({
  selector: '[uex-table-header]',
  templateUrl: './header.component.html',
  host: {
    'class': 'uex-table-header'
  }
})
export class TableHeaderComponent {
  @Input() table: Table;
}
